import React from 'react';
import NotFound from './../../NotFound';
import RoutineWork from '../components/RoutineWork';
import Main from '../components/Main';

export default function template() {
    let Component = null,
        {match = {}} = this.props;

    if (match.params && match.params.type) {
        switch (match.params.type) {
            case 'routine_work':
                Component = RoutineWork;
                break;
            default:
                Component = NotFound;
                break;
        }
    } else {
        Component = Main;
    }

    return (
        <Component
            {...this.props}
            widgets_routine_work={this.state.widgets_routine_work}
            widgets_routine_work_loading={this.state.widgets_routine_work_loading}
        />
    );
}
